import type { IconProps as Props } from './types';

export const IconFiles = ({
  width = '1em',
  height = '1em',
  stroke = 'currentColor',
  title = 'Files',
  ...rest
}: Props) => {
  return (
    <svg width={width} height={height} fill="none" viewBox="0 0 16 16" {...rest}>
      <title>{title}</title>
      <path
        fill="currentColor"
        d="M2.098 2.098A1.7 1.7 0 0 1 3.3 1.6h6.6a1.7 1.7 0 0 1 1.7 1.7v.233h-1.2V3.3a.5.5 0 0 0-.5-.5H3.3a.5.5 0 0 0-.5.5v6.6a.5.5 0 0 0 .5.5h.233v1.2H3.3a1.7 1.7 0 0 1-1.7-1.7V3.3c0-.45.18-.883.498-1.202Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.7 4A1.7 1.7 0 0 0 4 5.7v6.6A1.7 1.7 0 0 0 5.7 14h6.6a1.7 1.7 0 0 0 1.7-1.7V5.7A1.7 1.7 0 0 0 12.3 4H5.7Zm-.354 1.347A.5.5 0 0 1 5.7 5.2h6.6a.5.5 0 0 1 .5.5v6.6a.5.5 0 0 1-.5.5H5.7a.5.5 0 0 1-.5-.5V5.7a.5.5 0 0 1 .146-.353Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
